import { cva } from '@/styled-system/css';

export const pageHeaderRecipe = cva({
  base: {
    'boxSizing': 'content-box',
    'display': 'flex',
    'justifyContent': 'space-between',
    'alignItems': 'center',
    'marginBlockStart': {
      base: 'Page.Header.margin.top.mobile',
      md: 'Page.Header.margin.top.tablet',
      xl: 'Page.Header.margin.top.desktop',
    },
    'marginBlockEnd': {
      base: 'Page.Header.margin.bottom.mobile',
      md: 'Page.Header.margin.bottom.tablet',
      xl: 'Page.Header.margin.bottom.desktop',
    },
    'marginInline': 'auto',
    'paddingInline': {
      base: 'Page.padding.horz.mobile',
      md: 'Page.padding.horz.tablet',
      xl: 'Page.padding.horz.desktop',
    },
    '& .c11n_heading': {
      textStyle: 'responsive.heading-lg',
      fontFamily: 'brand',
    },
  },
  variants: {
    fluid: {
      true: {
        maxWidth: 'none',
      },
      false: {
        maxWidth: '1280px',
      },
    },
  },
});
